/**
 * 成員簡介
 * Created at 2021-10-02 15:55、
 * 这里是真不想改 就这样吧  没心思改
 * @author teapot
 */
import { useHistory } from 'react-router';
import "../../../../src/pages/about/adviser/index.css"
import './index.css';
import { useEffect } from 'react';
import { Button, Form, Image, Input, List, message, Modal } from "antd";
import { useTranslation } from "react-i18next";
//  import { useState } from "react";
//  import joinImg from "./images/join.png";
//  import http from "../../../service/http";
//  import joinus from './images/joinus.png'
import { locals } from "../../../i18n";
import Config from "../../../config";
import { adviserAsync, setAdviserItem, setAdviserModel, setTinkTankItem, setTinkTankModel, tinkTankAsync } from "../../../store/AboutStore";
// import { title } from "process";
import ThinktankrAddresss from "./thinktankAddress";

import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { RootState } from "../../../app/store";
import titleCN from './image/tinktank.png';
import title from './image/tinktank-cn.png';

const JoinUs = () => {
  const { t } = useTranslation();
  const { tinkTankList, tinkTankItem, tinkTankModel } = useAppSelector(
    (state: RootState) => state.about
  );
  const dispatch = useAppDispatch();
  const history = useHistory()
  useEffect(() => {
    dispatch(tinkTankAsync());
  }, [dispatch]);

  return (
    <div className='adviser'>
      {/* <div className="adviser-title adviser-title-size">
         {t("nav_us_adviser")}
       </div> */}
      <ThinktankrAddresss />
      {/* <div className="line"></div> */}
      <Image
        src={locals() === 'zh-CN' ? titleCN : title}
        preview={false}
        className='title-bottom'
      />

      <List
        grid={{
          gutter: 16,
          xs: 1,
          sm: 2,
          md: 2,
          lg: 2,
          xl: 2,
          xxl: 3,
        }}
        locale={{ emptyText: t('nodata') }}
        dataSource={tinkTankList}
        renderItem={(item) => {
          return (
            <List.Item
              onClick={() => {
                dispatch(setTinkTankItem(item));
              }}
            >
              <div className='adviser-item'>
                <Image
                  alt={item.name}
                  className={'adviser-item-img'}
                  src={`${Config.MAIN_URL}${item.img}`}
                  preview={false}
                />
                <div className='adviser-placeholder adviser-item-right tinktank-item-image-title tinktank-item-image-title-phone'>
                  {item.name}
                </div>
              </div>
            </List.Item>
          );
        }}
      />

      <Modal
        visible={tinkTankModel}
        closable={false}
        width={750}
        onCancel={() => {
          dispatch(setTinkTankModel(false));
        }}
        footer={null}
        bodyStyle={{
          backgroundColor: '#f5f5f5',
        }}
      >
        {tinkTankItem ? (
          <div className='adviser-item'>
            <Image
              alt={tinkTankItem.name}
              className={'adviser-item-img'}
              src={`${Config.MAIN_URL}${tinkTankItem.img}`}
              preview={false}
            />
            <div className='adviser-placeholder adviser-item-right tinktank-item-image-title news-item-image-title-phone'>
              {tinkTankItem.name}

              <div className='tinktank-item-middle-content tinktank-item-middle-content-phone'>
                {tinkTankItem.title &&
                  tinkTankItem.title.split(';').map((v, k) => {
                    return <div key={k}> {v}</div>;
                  })}
              </div>

              {tinkTankItem.pdf ? 
              <div className='More' onClick={() => { window.location.href = (`${Config.MAIN_URL}${tinkTankItem.pdf}`) }}><span className='underline'>了解更多     </span> <span>→</span></div>
               : null}

            </div>
          </div>
        ) : null}
      </Modal>
    </div>
  );
};
export default JoinUs;
function dispatch(arg0: any) {
  throw new Error("Function not implemented.");
}

